import React from "react";

interface AccessAvatarProps {
  src: string;
  alt: string;
  size: number;
  ringed?: boolean; // adds a 2px white ring for stacked avatars
}

// Plain native <img>. Primer Box-as-img stripped/aliased the src prop in
// some configurations, leaving the browser with no source to load.
export const AccessAvatar: React.FC<AccessAvatarProps> = ({ src, alt, size, ringed }) => (
  <img
    src={src}
    alt={alt}
    width={size}
    height={size}
    style={{
      borderRadius: "50%",
      flexShrink: 0,
      display: "block",
      objectFit: "cover",
      boxShadow: ringed ? "0 0 0 2px var(--bgColor-default, #fff)" : undefined,
    }}
  />
);
